<template>
    <div class="info">
        <div class="up">
            <div class="option" v-for="(item,i) in upInfoList" :key="i">
                <span class="title">{{ item.word }}</span>
                <span class="num">{{ item.num }}</span>
            </div>
        </div>
        <div class="down">
            <div class="option" v-for="(item,i) in downInfoList" :key="i">
                <span class="num">{{ item.num }}</span>
                <span class="word">{{ item.word }}</span>
            </div>
        </div>
    </div>    
</template>
<script>
import miment from 'miment';
export default {
    data(){
        return {
            upInfoList: [
                {
                    num: 0,
                    word: '摸排总人数',
                    prop: "touchUserCount"
                },
                {
                    num: 0,
                    word: "注册用户数",
                    prop: "registerUserCount"
                },
                {
                    num: 0,
                    word: "已上班人数",
                    prop: "goCompanyCount"
                }
            ],
            downInfoList: [
                {
                    num: 0,
                    word: "发热人数",
                    prop: "feverUserCount"
                },
                {
                    num: 0,
                    word: "当日进出人次",
                    prop: "walkUserCount"
                }
            ]
        }
    },
    props: {
        date: {
            type: String
        }
    },
    methods: {
        // 获取信息
        async getInfo(starttime,endtime){
            let res = await Promise.all([
                this.$get(this.urlobj.getEpidemicUserCount,{
                    communityId:this.$route.query.communityId || this.$store.state.streetorcommunityid,
                    beginTime: starttime,
                    endTime: endtime
                }),
                this.$get(this.urlobj.getEpidemicUserInfo,{
                    communityId:this.$route.query.communityId || this.$store.state.streetorcommunityid,
                    beginTime: starttime,
                    endTime: endtime
                })
            ])
            Object.keys(res[0].rows[0]).forEach(item => {
                if(this.downInfoList.find(citem => citem.prop == item)){
                    this.downInfoList.find(citem => citem.prop == item).num = res[0].rows[0][item]
                }
            })
            Object.keys(res[1].rows[0]).forEach(item => {
                if(this.upInfoList.find(citem => citem.prop == item)){
                    this.upInfoList.find(citem => citem.prop == item).num = res[1].rows[0][item]
                }
            })
        }
    },
    watch: {
        date(newVal){
            let starttime,endtime

            

            if(newVal == '日期选择'){
                this.getInfo();
                return
            }

            if(newVal.length == 6){
                let year = newVal.substring(0,4);
                let month = newVal.substring(4);
                starttime = miment(year + '-' + month + '-' + '01').format('YYYY-MM-DD');
                endtime = miment(year + '-' + month + '-' + new Date(year,month,0).getDate()).format('YYYY-MM-DD');
            }else if(newVal.length == 8){
                let year = newVal.substring(0,4);
                let month = newVal.substring(4,6);
                let date = newVal.substring(6,7);
                starttime = miment(year + '-' + month + '-' + date).format('YYYY-MM-DD');
                endtime = miment(year + '-' + month + '-' + date).format('YYYY-MM-DD');
            }
            this.getInfo(starttime,endtime)
        }
    },
    created(){
        this.getInfo();
    }
}
</script>
<style lang="less" scoped>
.info {
    box-sizing: border-box;
    padding: 10px 0 15px;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    .up{
        display: flex;
        align-items: center;
        .option {
            flex: 1;
            text-align: center;
            border-right: 1px solid #2f3448;
            .title {
                font-size: 14px;
                color: #959cb8;
                margin-right: 10px;
            }
            .num {
                font-size: 18px;
                color: #1c71e8;
                font-weight: 800;
            }
        }
    }
    .down {
        padding: 0 90px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        .option{
            flex: 1;
            display: flex;
            flex-flow: column;
            align-items: center;
            border-right: 1px solid #2f3448;
            .num {
                font-size: 18px;
                color: #ff4448;
                margin-bottom: 10px;
                font-weight: 800;
            }
            .word {
                font-size: 14px;
                color: #9399b1;
            }
        }
    }
    .option:last-of-type{
        border-right: none;
    }
}
</style>